function setCookie(name, value, daysToLive) {
  let cookie = name + '=' + encodeURIComponent(value);

  if (typeof daysToLive === 'number') {
    cookie += '; max-age=' + daysToLive * 24 * 60 * 60;
    document.cookie = cookie;
  }
}

function getCookie(name) {
  let cookieArr = document.cookie.split(';');
  for (let i = 0; i < cookieArr.length; i++) {
    let cookiePair = cookieArr[i].split('=');

    if (name == cookiePair[0].trim()) {
      return decodeURIComponent(cookiePair[1]);
    }
  }

  return null;
}

/* Source for Cookies: https://www.tutorialrepublic.com/javascript-tutorial/javascript-cookies.php */

const announcementBar = document.querySelector('.announcement-bar') || false;

if (announcementBar) {
  const announcementCookie = getCookie('announcementCookie');

  if (announcementCookie !== 'dismiss') {
    announcementBar.style.display = 'block';

    const announcementClose = announcementBar.querySelector(
      '.announcement-bar-close'
    );
    announcementClose.addEventListener('click', () => {
      announcementBar.style.display = 'none';
      setCookie('announcementCookie', 'dismiss', 1);
    });
  }
}
